import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import {
  Theme,
  Card,
  Flex,
  Text,
  TextField,
  Button,
  Link,
} from "@radix-ui/themes";
import { API_URL } from "../constants/constants";

function Signup() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    await axios.post(`${API_URL}/api/auth/signup`, form);
    navigate("/dashboard");
  };

  return (
    <Theme appearance="dark" accentColor="crimson" radius="medium">
      <Flex
        align="center"
        justify="center"
        style={{ minHeight: "100vh", padding: "1rem" }}
      >
        <Card size="3" style={{ width: "100%", maxWidth: "400px" }}>
          <Flex direction="column" gap="4">
            <Text size="5" weight="bold" align="center">
              Create an account
            </Text>

            <TextField.Root
              type="text"
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              required
            />

            <TextField.Root
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              required
            />

            <TextField.Root
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />

            <Button onClick={handleSubmit}>Sign Up</Button>

            <Text size="2" align="center" style={{ marginTop: "1rem" }}>
              Already have an account?{" "}
              <Link asChild color="crimson">
                <RouterLink to="/login">Sign in.</RouterLink>
              </Link>
            </Text>
          </Flex>
        </Card>
      </Flex>
    </Theme>
  );
}

export default Signup;
